import type { ReactNode } from 'react';
import { CevopBrand, Avatar, EmptyState, PageHeader as UiPageHeader, PageHeaderBack } from '@cevop/ui';
import { StatusBadge } from './StatusBadge';

export { Avatar, EmptyState, PageHeaderBack };

export function BrandMark() {
  return <CevopBrand wordmarkHeight={22} product="Backroom" />;
}

/** Admin page header — delegates to @cevop/ui PageHeader, with Backroom chrome. */
export function PageHeader({
  title,
  subtitle,
  leading,
  actions,
  status,
  meta,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  /** Prefer PageHeaderBack for nested detail screens. */
  leading?: ReactNode;
  actions?: ReactNode;
  status?: ReactNode;
  meta?: ReactNode;
}) {
  return (
    <UiPageHeader
      className="page-header"
      title={title}
      description={typeof subtitle === 'string' ? subtitle : undefined}
      meta={meta ?? (typeof subtitle !== 'string' ? subtitle : undefined)}
      leading={leading}
      actions={actions}
      status={status}
    />
  );
}

export function HealthRow({ label, value, badge }: { label: string; value: ReactNode; badge?: string }) {
  return (
    <div className="health-row">
      <span className="health-row__label">{label}</span>
      <span className="health-row__value">
        {value}
        {badge ? <StatusBadge status={badge} /> : null}
      </span>
    </div>
  );
}

export function TabBar({
  tabs,
  value,
  onChange,
}: {
  tabs: Array<{ id: string; label: string; count?: number }>;
  value: string;
  onChange: (id: string) => void;
}) {
  return (
    <div className="tab-bar">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          className={`tab${value === tab.id ? ' active' : ''}`}
          onClick={() => onChange(tab.id)}
        >
          {tab.label}
          {tab.count != null && <span className="tab__count">{tab.count}</span>}
        </button>
      ))}
    </div>
  );
}
